import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of, tap } from 'rxjs';
import * as AuthSelectors from '../auth/store/selectors/auth.selector';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../core/servises/auth/auth.service';
import { permissionsHelper } from '../helpers/permissions.helper';
import * as AuthActions from '../auth/store/actions/auth.actions';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private _permissions$: Observable<Array<string>> = this._store.select(AuthSelectors.permissions);

  private _permissions: Array<string>;

  constructor(
    private _store: Store,
    private _authService: AuthService,
  ) {
    this._permissions$.subscribe(permissions => {
      this._permissions = permissions;
    });
  }

  public hasPermission(scopes: Array<string>): boolean {
    return scopes.length
      && this._permissions.length
      && scopes.every(scope => this._permissions.includes(scope));
  }

  public updatePermissions$(scopes: Array<string>): Observable<boolean> {
    return this._authService.getUserData()
      .pipe(
        tap(userInfo => {
          this._store.dispatch(AuthActions.setUserInfo({
            userInfo: {
              id: userInfo.id,
              name: userInfo.name,
              role: <string>userInfo.role,
              email: userInfo.email,
              sharedOrgs: userInfo.shared_orgs.map(org => ({
                id: org.id,
                name: org.name,
              })),
              orgEnabledOtp: userInfo.org_enable_otp,
              enabledOtp: userInfo.enable_otp,
            },
          }));
        }),
        map(userData => {
          this._permissions = permissionsHelper(userData.scopes);

          return this.hasPermission(scopes);
        }),
        catchError(() => of(false)),
      );
  }

  public hasPermission$(scopes: string[]): Observable<boolean> {
    return this._permissions$
      .pipe(
        map(permissions =>
          scopes.length
          && permissions.length
          && scopes.every(scope => permissions.includes(scope)),
        ),
      );
  }
}
